import React, {useState} from 'react';
import Deliveries from "../../components/dashboard/Deliveries";
import Loader from "react-loaders";
import {Redirect} from "react-router-dom";
import DashboardDeliveryQuote from "../../components/dashboard/DashboardDeliveryQuote";
import models from "../../network/models/quick_models";
import general_helper from "../../helpers/general_helper";
import RiderStats from "../../components/dashboard/RiderStats";


const RidersHome = () => {

    const [change, setChange] = useState({
        state: false,
        componentType: "location-form",
        componentSubType: "deliveries",
        deliveryOrder: models.deliveryRequest
    });

    const handleViewChange = ({state, componentType, componentSubType, deliveryRequestModel}) => {
        setChange({
            state: state,
            componentType: componentType,
            componentSubType: componentSubType,
            deliveryOrder: deliveryRequestModel
        });
    };

    const sideView = ({state, componentType, componentSubType}) => {
        switch (componentSubType) {
            case "deliveries":
                // Pass the deliveries type to fetch
                // 1. rider
                // 2. user
                return <Deliveries type={general_helper.deliveryType.rider}/>;
            case "delivery-quote":
                return (
                    <>
                        <a className="action-link"
                           style={{fontWeight: "bold", marginBottom: 50, float: "left"}}
                           onClick={() => {
                               handleViewChange(
                                   {
                                       state: true,
                                       componentType: "location-form",
                                       componentSubType: "deliveries"
                                   }
                               )
                           }}>Back</a>
                        <DashboardDeliveryQuote change={{current: change}}/>
                    </>
                );

            case "loading":
                return (<div className="row justify-content-center">
                    <div className="col-md-5 col-sm-6">
                        <div className="text-center">
                            <Loader type="ball-scale"/>
                        </div>
                    </div>
                </div>);
            case "redirect":
                return <Redirect to="/home"/>;
            default:
                return null;
        }
    };


    return (
        <div className="main-wrapper">
            <div className="container">
                <div className="dashboard">
                    <div className="row justify-content-around">
                        <div className="col-md-5 d-none d-sm-block">
                            <div style={{marginTop: 100}}>
                                {sideView(change)}
                            </div>
                        </div>

                        <div className="col-md-5">
                            <div className="center-block align-middle">
                                <div className="container">
                                    <RiderStats/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default RidersHome;
